import React, { FC, ReactElement } from 'react';
import { Fail } from 'b2b-apps/shop/common/components/Fail';
import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { isEmpty } from 'b2b-apps/shop/common/utils/empty/empty';

const withEmptyDataHandler = <P, R extends RemoteRecord<any> = RemoteRecord<any>>(
  getRemoteRecords: (props: P) => R[],
) => (Component: FC<P>): FC<P> => {
    const WithEmptyDataHandler = (props: P): ReactElement => {
      const remoteRecords = getRemoteRecords(props);

      for (const remoteRecord of remoteRecords) {
        const { data, error, isLoaded, hasFailed } = remoteRecord;

        if ((isLoaded || hasFailed) && isEmpty(data)) {
          return <Fail error={error} />;
        }
      }

      return <Component {...props} />;
    };

    return WithEmptyDataHandler;
  };

export { withEmptyDataHandler };
